module.exports = __webpack_public_path__ + "img/do.do3ecb625.svg";